export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TabVerificaNote.vue?vue&type=template&id=0872c110&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabVerificaNote.vue?vue&type=template&id=0872c110&
// module id = 815
// module chunks = 0